module.exports = __webpack_public_path__ + "img/bg15.d868f16d.jpg";